"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadBuffer = void 0;
const buffer_1 = require("buffer");
const loadBuffer = () => buffer_1.Buffer;
exports.loadBuffer = loadBuffer;
